import { Box, Typography, Link, Container } from "@mui/material";
import InstagramIcon from "@mui/icons-material/Instagram";

// Constants
const INSTAGRAM_URL = "https://www.instagram.com/nicolehahndesigns/";
const LOCATION = "Greater Seattle Area";

// Extracted styles for better maintainability
const styles = {
  footer: {
    backgroundColor: "#F5F5F5",
    color: "black",
    padding: { xs: "2rem", sm: "3rem", md: "5rem" },
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    textAlign: "center",
    component: "footer",
    role: "contentinfo",
  },
  location: {
    flex: 1,
    textAlign: { xs: "center", sm: "left" },
    fontSize: { xs: "1rem", md: "1.25rem" },
    paddingLeft: { xs: "0", sm: "0", md: "0" },
    marginBottom: { xs: "1rem", sm: "0" },
  },
  socialContainer: {
    flex: 1,
    textAlign: { xs: "center", sm: "right" },
  },
  socialLink: {
    color: "black",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: { xs: "center", sm: "flex-end" },
    fontSize: { xs: "1rem", md: "1.25rem" },
    transition: "opacity 0.3s ease",
    "&:hover": {
      opacity: 0.8,
    },
    "&:focus-visible": {
      outline: "2px solid #000",
      outlineOffset: "2px",
    },
  },
  socialIcon: {
    fontSize: { xs: 32, md: 40 },
    paddingRight: { xs: "0", sm: "0", md: "0" },
    transition: "transform 0.3s ease",
    "&:hover": {
      transform: "scale(1.1)",
    },
  },
};

/**
 * Footer component that displays location and social media links
 * @returns {JSX.Element} The rendered Footer component
 */
const Footer = () => {
  return (
    <Box
      component="footer"
      role="contentinfo"
      aria-label="Footer"
      sx={styles.footer}
    >
      <Container maxWidth="lg" sx={{ display: "flex", flexWrap: "wrap" }}>
        {/* Location Section */}
        <Typography
          variant="h6"
          component="p"
          sx={{
            ...styles.location,
            fontFamily: '"Old Standard TT", serif'
          }}
          aria-label="Business location"
        >
          {LOCATION}
        </Typography>

        {/* Social Media Section */}
        <Box sx={styles.socialContainer}>
          <Link
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            sx={styles.socialLink}
            aria-label="Visit Nicole Hahn Designs on Instagram"
          >
            <InstagramIcon sx={styles.socialIcon} />
          </Link>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;